import DateFnsUtils from '@date-io/date-fns'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import es from 'date-fns/locale/es'
import moment from 'moment'

const DateFilter = ({
  filterList,
  onChange,
  index,
  column,
  label,
  selectedDate,
  handleDateChange,
}) => {
  const handleChange = (date) => {
    const formattedDate = moment(date).format('YYYY-MM-DD')
    filterList[index] = [formattedDate]
    onChange(filterList[index], index, column)
    handleDateChange(date)
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
      <KeyboardDatePicker
        autoOk
        variant="inline"
        format="dd/MM/yyyy"
        margin="normal"
        label={label}
        value={selectedDate}
        onChange={handleChange}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
      />
    </MuiPickersUtilsProvider>
  )
}

export default DateFilter
